const helpContact = {
    init: function () {
        let _self = this;
        let b = $('#help-contact-js');
        axios.post(b.attr('data-root-url'))
            .then(function (response) {
                let data = response.data;
                b.find('.main-level-section').html(_self.template(b.attr('data-first-question'), data));
            });
    },
    template: function (title, data) {
        let _self = this;
        let h = `<h3>${title}</h3>`;
        let inputName = null;

        let options = data.options;

        if (data.option_type === 'select') {
            inputName = 'level' + (data.parent_id ? data.parent_id : 0);
            h += '<div class="form-group clearfix"><select name="' + inputName + '" class="form-control hc-selected hc-subject">';
            h += '<option value="">Select a question</option>';
            Object.keys(options).forEach(function (k) {
                h += '<option value="' + options[k].id + '">' + options[k].name + '</option>';
            });
            h += '</div>';

        } else {
            Object.keys(options).forEach(function (k) {
                inputName = 'level' + (options[k].parent_id ? options[k].parent_id : 0);
                h += _self.radioOption(options[k].name, options[k].id, inputName);
            });
        }

        return h;
    },
    contactActionTemplate: function (type) {
        let b = $('#help-contact-js');
        if (type === 'button') {
            return '<button class="btn btn-primary hc-contact-btn-js">' + b.attr('data-contact-question-one') + '</button>';
        } else {
            return `<h3>${b.attr('data-contact-question-two')}</h3>
                   <div>
                <div class="acf-radio">
                    <label for="hc-contact-yes">
                        <input id="hc-contact-yes" class="radio-input" type="radio" value="1" name="hc-contact-radio">
                           Yes
                    </label>
                </div>
                <div class="acf-radio">
                    <label for="hc-contact-no">
                        <input id="hc-contact-no" class="radio-input" type="radio" value="0" name="hc-contact-radio">
                        No
                    </label>
                </div>
            </div>`;
        }
    },
    radioOption: function (label, id, name) {
        return `<div class="acf-radio">
                    <label for="acf-radio-${id}">
                        <input id="acf-radio-${id}" class="hc-selected" type="radio" value="${id}" name="${name}">
                            ${label}
                    </label>
                </div>`;
    },
    fetch: function (clickedEl, id) {
        let _self = this;
        let b = $('#help-contact-js');
        let url = b.attr('data-fetch-url') + '/' + id;
        axios.post(url)
            .then(function (response) {
                let data = response.data;
                let nestedClassName = 'sub-nested-list';
                let subSection = b.find('.sub-level-section');
                let hasNest = b.find('.' + nestedClassName).length > 0;
                let isTopTopic = clickedEl.closest('.main-level-section').length > 0;
                let infoSection = b.find('.info-level-section');
                let contactSection = b.find('.contact-level-section');

                infoSection.hide();
                contactSection.find('.cls-top,.cls-middle').hide();

                if (data.has_ended) {

                    if (data.info_title && data.info_description) {
                        infoSection.find('.card-header').text(data.info_title);
                        infoSection.find('.card-body').html(data.info_description);
                        infoSection.show();
                    }

                    if (data.button_action !== 'none') {
                        contactSection.show();
                        contactSection.find('.cls-top').show().html(_self.contactActionTemplate(data.button_action));
                    }

                    if (isTopTopic) {
                        subSection.hide().html('');
                    }

                    $('.hc-extra-field').each(function () {
                        $(this).addClass('hc-hide');
                        $(this).find('input').attr('required', false);
                        $(this).find('select').attr('required', false);
                    });

                    for (const [field, required] of Object.entries(data.fields)) {
                        let $elem = $(`.hc-${field}-block`);
                        $elem.removeClass('hc-hide');

                        if (required) {
                            $elem.find('input').attr('required', true);
                            $elem.find('select').attr('required', true);
                        }
                    }


                    if (data.info_msg_box) {
                        $('.hc-msg-box-block .help-block').eq(0).text(data.info_msg_box);
                    }

                    //Fallback
                    let topicId = $('input#topic_id').val();

                    if (topicId === '') {
                        $('input#topic_id').val(data.id);
                    }
                } else {
                    if (hasNest && isTopTopic === false) {
                        let nestedDiv = clickedEl.closest('.sub-nested-list');

                        if (nestedDiv.find('.' + nestedClassName).length) {
                            nestedDiv.find('.' + nestedClassName).remove();
                        }

                        clickedEl.closest('.' + nestedClassName).append(`<div class="${nestedClassName}">${_self.template(data.question, data)}</div>`);
                    } else {
                        subSection.show();
                        subSection.html(`<div class="${nestedClassName}">${_self.template(data.question, data)}</div>`);
                    }
                }
            });
    },
};

function recaptchaReload() {
    if (window.hasOwnProperty('grecaptcha')) {
        grecaptcha.reset();
    }
}

if ($('#help-contact-js').length) {
    helpContact.init();

    $(document).on('change', '.hc-selected', function () {
        let _self = $(this);
        let id = parseInt(_self.val());

        if (isNaN(id)) {
            return false;
        }

        helpContact.fetch(_self, id);

        if (_self.hasClass('hc-subject')) {
            $('input#topic_id').val(id);
        }

        let topicSelected = [];
        $('.hc-selected:checked, .hc-selected option:selected').each(function () {
            let v = $(this).val();
            topicSelected.push(v);
        });

        if (topicSelected.length) {
            $('input#topic_selected').val(topicSelected.toString());
        }

        return false;
    });

    $(document).on('click', '.hc-contact-btn-js', function () {
        $('.contact-level-section .cls-middle').slideDown('slow', function () {
            // $('body,html').animate({
            //     scrollTop: $(".contact-level-section h2:first-child").offset().top
            // }, 2000);
        });
        return false;
    });

    $(document).on('change', 'input[name="hc-contact-radio"]', function () {
        let _self = $(this);
        if (parseInt(_self.val()) === 1) {
            $('.contact-level-section .cls-middle').slideDown('slow');
            // $('.contact-level-section .cls-middle').slideDown('slow', function () {
            //     $('body,html').animate({
            //         scrollTop: $(".contact-level-section h2:first-child").offset().top
            //     }, 2000);
            // });
        } else {
            $('.contact-level-section .cls-middle').slideUp('fast');
        }
        return false;
    });

    $(document).on('submit', '#hc-form', function () {
        let _self = $(this);
        let b = $('#help-contact-js');
        let submitBtn = _self.find('button[type="submit"]');
        let formData = new FormData(this);

        submitBtn.attr('disabled', true);

        axios.post(_self.attr('action'), formData)
            .then(function (response) {
                let data = response.data;
                if (data.success) {
                    window.location = b.attr('data-form-success-url');
                }
                submitBtn.attr('disabled', false);
            }).catch(function (error) {

            submitBtn.attr('disabled', false);

            recaptchaReload();

            if (error.response.status === 422) {
                let errorData = error.response.data.errors;

                Object.keys(errorData).forEach(function (key, index) {
                    const inputEl = $('#' + key);
                    const parent = inputEl.closest('.form-group');
                    console.log(key, inputEl, parent)

                    parent.removeClass('has-success').addClass('has-error');
                    parent.find('.error-block').end().find('.error-msg').text(errorData[key][0]);
                });

                let $errorElement = $("#hc-form .has-error");
                if ($errorElement.length) {
                    $('body,html').animate({
                        scrollTop: $errorElement.offset().top
                    }, 2000);
                }
            }
        });

        return false;
    });

    $(document).on('change keyup', '#hc-form input, #hc-form select, #hc-form textarea', function () {
        let _self = $(this);
        _self.closest('.form-group').removeClass('has-error');
    });

    $(document).on('change', 'input[name="insurance_type_field"]', function () {
        let _self = $(this);
        let val = $(this).val();

        if (val === 'car' || val === 'van') {

            $('.hc-property-block').hide();
            $('.hc-property-block input').attr('required', false);

            $('.hc-vehicle-registration-block').show();
            $('.hc-vehicle-registration-block input').attr('required', true);

        } else if (val === 'home') {
            $('.hc-vehicle-registration-block').hide();
            $('.hc-vehicle-registration-block input').attr('required', false);

            $('.hc-property-block').show();
            $('.hc-property-block input').attr('required', true);
        } else {
            $('.hc-vehicle-registration-block, .hc-property-block').hide();
            $('.hc-vehicle-registration-block input, .hc-property-block input').attr('required', false);
        }

        return false;
    });
}
